var _rect, _g, _rect2, _g2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5,
    fill: "#395CD6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1875 4.99998H7.34375C6.05141 4.99998 5 6.05139 5 7.34373V10.1875C5 11.4798 6.05141 12.5312 7.34375 12.5312H10.1875C11.4798 12.5312 12.5312 11.4798 12.5312 10.1875V7.34373C12.5312 6.05139 11.4798 4.99998 10.1875 4.99998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6562 13.4687H15.8125C14.5202 13.4687 13.4688 14.5201 13.4688 15.8125V18.6562C13.4688 19.9486 14.5202 21 15.8125 21H18.6562C19.9486 21 21 19.9486 21 18.6562V15.8125C21 14.5201 19.9486 13.4687 18.6562 13.4687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6562 4.99998H15.8125C14.5202 4.99998 13.4688 6.05139 13.4688 7.34373V10.1875C13.4688 11.9968 11.9968 13.4687 10.1875 13.4687H7.34375C6.05141 13.4687 5 14.5201 5 15.8125V18.6562C5 19.9486 6.05141 21 7.34375 21H10.1875C11.4798 21 12.5312 19.9486 12.5312 18.6562V15.8125C12.5312 14.0032 14.0032 12.5312 15.8125 12.5312H18.6562C19.9486 12.5312 21 11.4798 21 10.1875V7.34373C21 6.05139 19.9486 4.99998 18.6562 4.99998Z",
    fill: "white"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5,
    fill: "#395CD6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0005 11.1742C14.8866 11.1742 16.421 9.63984 16.421 7.75377C16.421 5.86771 14.8866 4.33333 13.0005 4.33333C11.1145 4.33333 9.58008 5.86771 9.58008 7.75377C9.58008 9.63984 11.1145 11.1742 13.0005 11.1742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.59 12.8318C17.5885 12.8314 17.5857 12.8303 17.5843 12.83C17.1389 12.7212 15.7751 12.5304 15.7751 12.5304C15.6212 12.483 15.4567 12.5645 15.4013 12.7164L13.3485 18.3488C13.2301 18.6737 12.7705 18.6737 12.6521 18.3488L10.5993 12.7164C10.5546 12.5938 10.4388 12.5168 10.3147 12.5168C10.2853 12.5168 8.88306 12.7135 8.41623 12.8295C7.14057 13.1467 6.33594 14.4012 6.33594 15.7085V20.395C6.33594 21.0973 6.90531 21.6667 7.60763 21.6667H18.3918C19.0941 21.6667 19.6635 21.0973 19.6635 20.395V15.6929C19.6634 14.3912 18.8273 13.2361 17.59 12.8318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.774 12.423C13.6921 12.3337 13.5723 12.2888 13.4511 12.2888H12.5474C12.4263 12.2888 12.3064 12.3337 12.2246 12.423C12.0977 12.5612 12.0793 12.7608 12.1693 12.9168L12.6525 13.6451L12.4263 15.5529L12.8717 16.7377C12.9151 16.8568 13.0836 16.8568 13.127 16.7377L13.5724 15.5529L13.3462 13.6451L13.8293 12.9168C13.9193 12.7608 13.9008 12.5612 13.774 12.423Z",
    fill: "white"
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 5,
    fill: "#395CD6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1562 8.21875V9.0625C12.1562 9.15756 12.1501 9.25122 12.1396 9.34375H12.1562C12.4665 9.34375 12.7187 9.09147 12.7187 8.78125C12.7187 8.47103 12.4665 8.21875 12.1562 8.21875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4388 12.07L10.2965 11.5007C10.0822 11.5598 9.85777 11.5938 9.62518 11.5938C9.39259 11.5938 9.16815 11.5598 8.95384 11.5007L8.81152 12.07L9.62518 12.8837L10.4388 12.07Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06836 12.5019L8.39152 13.4716L9.12502 13.1783L8.4008 12.4541L8.06836 12.5019Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6685 7.74091C6.79984 7.68719 6.94328 7.65625 7.09375 7.65625H7.12216C7.25294 7.01528 7.82078 6.53125 8.5 6.53125H8.78125V7.09375H8.5C8.03481 7.09375 7.65625 7.47231 7.65625 7.9375V9.0625C7.65625 10.1478 8.53966 11.0312 9.625 11.0312C10.7103 11.0312 11.5938 10.1478 11.5938 9.0625V7.375H12.1562V7.65625C12.3067 7.65625 12.4502 7.68719 12.5815 7.74091L12.6091 7.6585C12.6819 7.43969 12.7188 7.21244 12.7188 6.98238C12.7188 5.80309 11.7594 4.84375 10.5801 4.84375H8.66959C7.49059 4.84375 6.53125 5.80309 6.53125 6.98238C6.53125 7.21244 6.56809 7.43997 6.64122 7.65878L6.6685 7.74091ZM8.21875 8.5C8.21875 8.34475 8.34475 8.21875 8.5 8.21875C8.65525 8.21875 8.78125 8.34475 8.78125 8.5C8.78125 8.65525 8.65525 8.78125 8.5 8.78125C8.34475 8.78125 8.21875 8.65525 8.21875 8.5ZM10.4688 6.53125H11.0312V6.97731C11.0312 7.15872 11.1018 7.32916 11.2301 7.45741L10.8324 7.85509C10.5978 7.62053 10.4688 7.30891 10.4688 6.97731V6.53125ZM10.75 8.21875C10.9053 8.21875 11.0312 8.34475 11.0312 8.5C11.0312 8.65525 10.9053 8.78125 10.75 8.78125C10.5947 8.78125 10.4688 8.65525 10.4688 8.5C10.4688 8.34475 10.5947 8.21875 10.75 8.21875ZM9.34375 6.53125H9.90625V6.97731C9.90625 7.15872 9.97684 7.32916 10.1051 7.45741L9.70741 7.85509C9.47284 7.62053 9.34375 7.30891 9.34375 6.97731V6.53125ZM9.0625 9.55863C9.16966 9.77294 9.38509 9.90625 9.625 9.90625C9.86491 9.90625 10.0803 9.77294 10.1875 9.55863L10.217 9.49928L10.7202 9.751L10.6907 9.81034C10.4876 10.2165 10.0792 10.4688 9.625 10.4688C9.17078 10.4688 8.76241 10.2165 8.55934 9.81006L8.52981 9.75072L9.03297 9.499L9.0625 9.55863Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1826 12.5019L10.8502 12.4541L10.126 13.1783L10.8595 13.4716L11.1826 12.5019Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2188 10.4688H17.7812V11.5938H17.2188V10.4688Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3438 4.84375H18.9062V5.96875H18.3438V4.84375Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2188 4.84375H17.7812V5.96875H17.2188V4.84375Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09375 9.34375H7.11034C7.09994 9.25122 7.09375 9.15756 7.09375 9.0625V8.21875C6.78353 8.21875 6.53125 8.47103 6.53125 8.78125C6.53125 9.09147 6.78353 9.34375 7.09375 9.34375Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5938 4.84375H19.4688V6.53125H16.6562V4.84375H15.5312V9.90625H20.5938V4.84375Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0938 10.4688H16.6562V11.5938H16.0938V10.4688Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53125 20.0312H7.09375V21.1562H6.53125V20.0312Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9062 16.0938H19.4688V17.2188H18.9062V16.0938Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4743 12.6873L11.7479 12.5836L11.2039 14.2162L9.625 13.5845L8.04634 14.2159L7.50241 12.5833L6.77594 12.6871C5.67428 12.8443 4.84375 13.8019 4.84375 14.9146V18.0629C4.84375 18.8383 5.47459 19.4691 6.25 19.4691H7.9375C8.09275 19.4691 8.21875 19.3431 8.21875 19.1879V17.7816H5.40625V17.2191H5.96875V14.9691H6.53125V17.2191H7.09375V15.5316C7.09375 15.2214 7.34603 14.9691 7.65625 14.9691H11.5938C11.904 14.9691 12.1562 15.2214 12.1562 15.5316V17.2191H12.7188V14.9691H13.2812V17.2191H13.8438V17.7816H12.1562V19.4691H13C13.7754 19.4691 14.4062 18.8383 14.4062 18.0629V14.9146C14.4062 13.8019 13.5757 12.8443 12.4743 12.6873Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7812 16.0938H18.3438V17.2188H17.7812V16.0938Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0312 16.0938V17.7812H17.2188V16.0938H16.0938V21.1562H21.1562V16.0938H20.0312Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4688 15.5312V10.4688H18.3438V12.1562H15.5312V10.4688H14.4062V13.2362C14.7595 13.7088 14.9688 14.2915 14.9688 14.9142V15.5312H19.4688Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1562 20.0312H12.7188V21.1562H12.1562V20.0312Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78125 15.5312H10.4688V16.0938H8.78125V15.5312Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0312 16.0938C11.0312 16.404 10.779 16.6562 10.4688 16.6562H8.78125C8.47103 16.6562 8.21875 16.404 8.21875 16.0938V15.5312H7.65625V17.2188H9.34375C9.96419 17.2188 10.4688 17.7233 10.4688 18.3438C10.4688 18.9642 9.96419 19.4688 9.34375 19.4688H8.7295C8.61306 19.7953 8.30369 20.0312 7.9375 20.0312H7.65625V21.1562H11.5938V15.5312H11.0312V16.0938Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90625 18.3438C9.90625 18.0335 9.65397 17.7812 9.34375 17.7812H8.78125V18.9062H9.34375C9.65397 18.9062 9.90625 18.654 9.90625 18.3438Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.3333,
    height: 17.3333,
    fill: "white",
    transform: "translate(4.33301 4.33333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(5 4.99998)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.3333,
    height: 17.3333,
    fill: "white",
    transform: "translate(4.33301 4.33333)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.3333,
    height: 17.3333,
    fill: "white",
    transform: "translate(4.33301 4.33333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.726f74d9187d2cff0696d3e25175c657.svg";
export { ForwardRef as ReactComponent };